export const getRemaining = (max: number, enrollments: number) => {
  const remaining = max - enrollments;
  if (remaining > 0) return `${remaining}`;
  else return "closed";
};
